import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { myStoresQuery } from "@/api/queries/selling";
import { sessionQuery } from "@/api/queries/session";
import { DashboardShell } from "@/components/layout/DashboardShell";

// Plan §4 journey 11: anonymous → /join, no Person → /welcome, a Person without a store → /sell.
export const Route = createFileRoute("/dashboard")({
  beforeLoad: async ({ context, location }) => {
    const session = await context.queryClient.ensureQueryData(sessionQuery());
    if (session.status === "anonymous") {
      throw redirect({ to: "/join", search: { returnTo: location.href } });
    }
    if (!session.person) {
      throw redirect({ to: "/welcome", search: { step: "identity", returnTo: location.href } });
    }
    const stores = await context.queryClient.fetchQuery(myStoresQuery());
    if (stores.length === 0) throw redirect({ to: "/sell" });
  },
  component: DashboardRouteLayout,
});

function DashboardRouteLayout() {
  return (
    <DashboardShell>
      <Outlet />
    </DashboardShell>
  );
}
